import React from 'react';
import voiceVerseLogo from '../images/voiceverse-logo.webp';
import { products } from '../data/products';

const voiceVerse = products.find(product => product.id === 'voiceverse');

const IntroVoiceVerse = () => {
    return (
        <>
                <div className="m-auto max-w-6xl scroll-mt-24 p-2 md:p-12 h-5/6" id='voiceverse' aria-labelledby='voiceverse-title' >

                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <img alt="VoiceVerse logo: an audio waveform forming a video play symbol" className="mx-auto w-full max-w-md object-contain" src={voiceVerseLogo} width="800" height="800" loading="lazy" decoding="async" />
                        </div>
                        <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8">
                            
                            <h2 id="voiceverse-title" className="text-3xl text-blue-900 font-bold">{voiceVerse.name}: {voiceVerse.subtitle}</h2>
                            <div>
                                <p className='my-3 text-xl text-gray-600 font-semibold'>{voiceVerse.description}</p>
                            </div>
                            
                            <div>
                                <p className='my-3 text-xl text-gray-600 font-semibold'>Build internal tools or customer-facing products with a service managed by MCN. Choose the capabilities your application needs, review the results, and arrange API access and integration support with our team.</p>
                            </div>
                            <div className="flex flex-col sm:flex-row gap-3">
                                <a href={`${voiceVerse.href}#contact`} className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-2 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0 group">
                                    Request API access
                                    <svg className="w-4 h-4 ml-1 group-hover: translate-x-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </a>
                                <a href={voiceVerse.href} className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-2 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0 group">
                                    {voiceVerse.cta}
                                    <svg className="w-4 h-4 ml-1 group-hover: translate-x-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default IntroVoiceVerse;
